<script>
import { Line } from 'vue-chartjs'
export default {
  props: ['chartData'],
  extends: Line,
  data() {
    return {
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: false
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [{
            gridLines: {
              display: true
            }
          }]
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  watch: {
    chartData: {
      handler() {
        this.renderChart(this.chartData, this.options)
      },
      deep: true
    }
  }
}
</script>